import React, {useContext, useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';

import {Container, Grid, LinearProgress} from '@mui/material';
import {PageHeader} from '../../common';
import {FetchContext, NavContext} from '../../contexts';
import {RegioneDetailsForm} from './components';
import {RegioneContext, RegioneProvider} from './RegioneContext';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        goBack
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingRegione,
        getRegioneAsync,

        isUpdatingRegione,
        updateRegioneAsync,

        isAddingRegione,
        addRegioneAsync,
    } = useContext(RegioneContext)

    const {
        regione,
    } = state;

    const {
        regioneId,
    } = useParams();

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    const regioneDetailsFormActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (regione) {
                    if (window.confirm("Confermare la modifica?")) {
                        await updateRegioneAsync(regioneId, data);
                    }
                } else {
                    if (window.confirm("Confermare l'inserimento?")) {
                        await addRegioneAsync(data);
                        goBack();
                    }
                }
                break;
            default:
                break;
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingRegione || isUpdatingRegione || isAddingRegione);
    }, [isLoadingRegione, isUpdatingRegione, isAddingRegione])

    useEffect(() => {
        if (user && regione)
            addBreadcrumbToken(regione.descrizione);
    }, [regione, user]);

    useEffect(() => {
        if (user) {
            if (!regioneId) {
                addBreadcrumbToken("Aggiungi");
            } else
                getRegioneAsync(regioneId);
        }
    }, [user]);

    return (
        <>
            <Container>
                {isLoading && <LinearProgress/>}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            save
                            onSaveClick={saveClickHandler}
                            title="Regione"
                            subtitle="Gestisci la regione"/>
                    </Grid>
                    <Grid item xs={12}>
                        <RegioneDetailsForm
                            onActionClick={regioneDetailsFormActionClickHandler}
                            disabled={isLoading}
                            formRef={formRef}/>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export const RegionePage = () => {

    return (
        <RegioneProvider>
            <PageContent/>
        </RegioneProvider>
    );
}